const packageJson = require('../package.json')
import locale from './locale'
import ApexLink from './ApexLink'
import ApexFilter from './ApexFilter'
import ApexDialog from './ApexDialog'
import ApexTable from './ApexTable'
import ApexForm from './ApexForm'
import ApexTreeSelect from './ApexTreeSelect'
import ApexSelect from './ApexSelect'
import ApexButton from './ApexButton'
import ApexTipButton from './ApexTipButton'
import ApexDatePicker from './ApexDatePicker'
import ApexNavigator from './ApexNavigator'

const components = [
  ApexLink,
  ApexFilter,
  ApexDialog,
  ApexTable,
  ApexForm,
  ApexTreeSelect,
  ApexSelect,
  ApexButton,
  ApexTipButton,
  ApexDatePicker,
  ApexNavigator
]

const install = function(Vue, opts = {}) {
  if (install.installed) return
  locale.use(opts.locale)
  locale.i18n(opts.i18n)
  components.forEach(component => {
    Vue.component(component.name, component)
  })
  Vue.prototype.$APEXUI = opts
}

// CDN引入时，便可使用所有组件
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: packageJson.version,
  locale: locale.use,
  i18n: locale.i18n,
  install,
  ApexLink,
  ApexFilter,
  ApexDialog,
  ApexTable,
  ApexForm,
  ApexTreeSelect,
  ApexSelect,
  ApexButton,
  ApexTipButton,
  ApexDatePicker,
  ApexNavigator
}
